// import axios from '@/plugins/axios'
// import { chunk, keyBy } from 'lodash'
import { Student } from '@/plugins/api'
// const USER_COURSE_API = 'https://3kv9lhxfki.execute-api.ap-southeast-1.amazonaws.com/prod/user-course'
// const STUDENT_API = 'https://zp21l6ud68.execute-api.ap-southeast-1.amazonaws.com/prod/student'
// const VENDORID = '49714800-4b02-11ea-a775-01bd84d6799a'
// const SIGNIN_API = 'https://aqa2l5zymk.execute-api.ap-southeast-1.amazonaws.com/prod/signin'
// const SUBMISSION_API = 'https://iptoqoeg36.execute-api.ap-southeast-1.amazonaws.com/prod/submission'

export default {
  namespaced: true,
  state: {
    student: {},
    authorizationToken: '',
    userCourses: [],
    page: 1,
    totalItems: 0,
    onlineStudyUserId: '',
    defaultDisplayCourseNum: 5,
    displayCourses: []
  },
  actions: {
    async loadMore({ commit, state, dispatch }) {
      const page = state.page + 1
      commit('changeState', { page })
      const displayCourses = state.userCourses.slice(0, page * 5)
      commit('changeState', {
        displayCourses
      })
    },

    async getUserCourses({ commit, state }, { student, role }) {
      if (student && student.code) {
        let { userCourses, totalItems, onlineStudyUserId } = await Student.getOnlineCourses({
          role,
          studentCode: student.code,
          onlineStudyUserId: student.code === state.student.code ? state.onlineStudyUserId : ''
        })

        commit('changeState', {
          userCourses: userCourses || [],
          displayCourses: userCourses ? userCourses.slice(0, state.defaultDisplayCourseNum) : [],
          totalItems,
          onlineStudyUserId,
          student
        })
      }
    }
  },
  mutations: {},
  getters: {}
}
